import React, { useState } from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import SearchForm from '@boschebike/ebds-react/dist-esm/components/SearchForm.js';
import SearchResults from '@boschebike/ebds-react/dist-esm/components/SearchResults.js';
import { useSearchSuggestionProvider } from '../../react/hooks/useSearchSuggestionProvider.js';

/**
 * @typedef {import('../../App.d.ts').ComponentSearchResultsProps} ComponentSearchResultsProps
 */
/**
 * @param {ComponentSearchResultsProps} props
 */
export default (props) => {
  // TODO: TRANSLATE THINGS!
  const [query, setQuery] = useState(props.query);
  const searchSuggestionProvider = useSearchSuggestionProvider(true);

  return (
    <>
      <Container isStandaloneText>
        <SearchForm
          data-testid="search-form"
          suggestionsProvider={searchSuggestionProvider}
          onSubmit={() => {
            location.href = `/search?q=${encodeURIComponent(query)}`;
          }}
          initialValue={query}
          onChange={(event) => setQuery(event?.detail?.value)}
        />
      </Container>
      <Container isStandaloneText>
        <h2>Search results</h2>
        <SearchResults
          data-testid="search-results"
          entries={props.list}
        />
      </Container>
    </>
  );
};
